module.exports = __webpack_public_path__ + "img/cooperate-bg.3c9b16a0.png";